import React, { useState } from 'react';
import './VueEtudiant.css';
import DashboardHeader from '../components/DashboardHeader';
import AdminNavigationBar from '../components/AdminNavigationBar';

function VueEtudiant() {
  const [showAddNoteModal, setShowAddNoteModal] = useState(false);
  const [showRecommandationModal, setShowRecommandationModal] = useState(false);
  const [showObservationModal, setShowObservationModal] = useState(false);

  const [noteFormData, setNoteFormData] = useState({
    francaisCommunication: '',
    francaisExpression: '',
    francaisLecture: '',
    francaisOrthographe: '',
    mathematique: '',
    educationSocialeEcrit: '',
    educationScientifiqueEcrit: '',
    eaPoesie: '',
    eaConte: '',
    eaDessin: '',
    educationSocialeAnglais: ''
  });

  const [recommandation, setRecommandation] = useState('');
  
  const [observationData, setObservationData] = useState({
    conduite: '',
    assiduite: '',
    application: ''
  });

  const studentInfo = {
    eleve: 'AVAVI Gildéric Donald',
    classe: 'CM2',
    nomEducMaster: 'Oriel ENAN',
    dateNaissance: '12/09/2003',
    midPhrase: 'Savè',
    dateInscription: '12/09/2003',
    matricule: '4x34876',
    personnelContacter: 'AVAVI Gilbert'
  };

  const notes = [
    { matiere: 'Français communication orale', note: '', sur: 20, appreciation: '' },
    { matiere: 'Français Expression écrite', note: '', sur: 20, appreciation: '' },
    { matiere: 'Français Lecture', note: '', sur: 20, appreciation: '' },
    { matiere: 'Français Orthographe', note: '', sur: 20, appreciation: '' },
    { matiere: 'Mathématique', note: '', sur: 20, appreciation: '' },
    { matiere: 'Education sociale (écrit)', note: '', sur: 20, appreciation: '' },
    { matiere: 'Education sociale (Oral)', note: '', sur: 20, appreciation: '' },
    { matiere: 'Education sociale (Anglais)', note: '', sur: 20, appreciation: '' },
    { matiere: 'Education Scientifique et Technologique (écrit)', note: '', sur: 20, appreciation: '' },
    { matiere: 'Education Scientifique et Technologique (oral)', note: '', sur: 20, appreciation: '' },
    { matiere: 'EA Poésie / Chant', note: '', sur: 20, appreciation: '' },
    { matiere: 'EA Conte / Couture', note: '', sur: 20, appreciation: '' },
    { matiere: 'EA Dessin', note: '', sur: 20, appreciation: '' },
    { matiere: 'EPS', note: '', sur: 20, appreciation: '' },
    { matiere: 'TOTAL', note: '', sur: 20, appreciation: '' }
  ];

  const handleNoteInputChange = (e) => {
    const { name, value } = e.target;
    setNoteFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleNoteSubmit = (e) => {
    e.preventDefault();
    console.log('Notes submitted:', noteFormData);
    setShowAddNoteModal(false);
  };

  const handleRecommandationSubmit = (e) => {
    e.preventDefault();
    console.log('Recommandation submitted:', recommandation);
    setShowRecommandationModal(false);
  };

  const handleObservationInputChange = (e) => {
    const { name, value } = e.target;
    setObservationData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleObservationSubmit = (e) => {
    e.preventDefault();
    console.log('Observation submitted:', observationData);
    setShowObservationModal(false);
  };

  return (
    <div className="admin-layout">
      <DashboardHeader />
      <AdminNavigationBar 
        title="Information de l'élève" 
        onBack={() => window.navigateTo && window.navigateTo('gestion-eleves')}
      />
      <div className="admin-container">
        <main className="admin-content admin-content-full">
          <div className="student-view-content">
            {/* Breadcrumb */}
            <div className="breadcrumb-section" style={{display: 'none'}}>
              <h1>Information de l'élève</h1>
              <div className="breadcrumb">
                <span>Accueil › Informations</span>
              </div>
            </div>

            <div className="main-layout-grid">
              {/* Left Column */}
              <div className="left-column">
                {/* Student Info Card */}
                <div className="student-info-main-card">
                  <div className="info-row-item">
                    <p className="info-label-small">L'élève</p>
                    <h3 className="info-value-main">{studentInfo.eleve}</h3>
                    <p className="info-subtext-small">Matricule n°xxxx</p>
                  </div>

                  <div className="info-row-item orange-bg">
                    <p className="info-label-small">Classe</p>
                    <h3 className="info-value-main">{studentInfo.classe}</h3>
                  </div>
                </div>

                {/* Evaluation Section */}
                <div className="evaluation-card">
                  <div className="eval-header">
                    <h3>Evaluation trimestrielle</h3>
                    <p className="eval-subtitle">Filtrer les données par trimestre</p>
                  </div>

                  <button className="action-btn-blue-full" onClick={() => setShowAddNoteModal(true)}>
                    Ajouter une note sur le bulletin
                    <br />
                    <small>Veuillez cliquer pour ajouter une note au bulletin</small>
                  </button>

                  <button className="action-btn-orange-full" onClick={() => setShowObservationModal(true)}>
                    Ajouter une observation
                    <br />
                    <small>Veuillez cliquer pour ajouter une observation</small>
                  </button>
                </div>

                {/* Bulletin Card */}
                <div className="bulletin-card">
                  <div className="bulletin-header-row">
                    <h4>Bulletin</h4>
                    <button className="refresh-icon-btn">🔄</button>
                  </div>

                  <p className="bulletin-subtitle-text">Evaluation Sommative Trimestrielle N°</p>
                  <p className="bulletin-subtitle-text">Ou sommative du mois de</p>

                  <h5 className="section-title-blue-bold">I - CONNAISSANCE ET HABILLETÉS</h5>

                  <div className="table-container">
                    <table className="notes-table-full">
                      <thead>
                        <tr>
                          <th>Champ de formation</th>
                          <th>Note</th>
                          <th>Sur</th>
                          <th>Appréciation</th>
                        </tr>
                      </thead>
                      <tbody>
                        {notes.map((item, index) => (
                          <tr key={index} className={item.matiere === 'TOTAL' ? 'total-row-bold' : ''}>
                            <td>{item.matiere}</td>
                            <td>{item.note}</td>
                            <td>{item.sur}</td>
                            <td>{item.appreciation}</td>
                          </tr>
                        ))}
                        <tr>
                          <td colSpan="4" className="rang-cell-bold"><strong>Rang :</strong></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  {/* Sub Tables */}
                  <div className="sub-tables-row">
                    <div className="table-wrapper-left">
                      <table className="sanctions-table-compact">
                        <thead>
                          <tr>
                            <th>Blâme</th>
                            <th>Avertissement</th>
                            <th>Tableau d'honneur</th>
                            <th>Encouragement</th>
                            <th>Félicitation</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Sanction</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div className="table-wrapper-right">
                      <table className="moyennes-table-compact">
                        <thead>
                          <tr>
                            <th>Moy. plus faible</th>
                            <th>Moy. de l'élève</th>
                            <th>Moy. plus élevée</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Comportement des moyennes</td>
                            <td></td>
                            <td></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  {/* Attitude */}
                  <h5 className="section-title-blue-bold">II - ATTITUDE</h5>
                  <div className="attitude-list">
                    <p><strong>Conduite :</strong> _______________</p>
                    <p><strong>Assiduité :</strong> _______________</p>
                    <p><strong>Application :</strong> _______________</p>
                  </div>

                  {/* Recommandation */}
                  <h5 className="section-title-blue-bold">III - RECOMMANDATION</h5>
                  <div className="recommandation-area" onClick={() => setShowRecommandationModal(true)}></div>

                  {/* Symboles */}
                  <h5 className="section-title-blue-bold">Symbole mérité par l'élève</h5>
                  <div className="symboles-flex">
                    <div className="symbole-box">
                      <span className="symbole-emoji">😐</span>
                    </div>
                    <div className="symbole-box">
                      <span className="symbole-circle">○</span>
                    </div>
                    <div className="symbole-box">
                      <span className="symbole-rect">▭</span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Right Column */}
              <div className="right-column">
                <div className="info-card-right">
                  <p className="info-label-small">Nom EducMaster</p>
                  <h3 className="info-value-main">{studentInfo.nomEducMaster}</h3>
                  <p className="info-subtext-small">Classe de 6/10/2025</p>
                </div>

                <div className="info-card-right">
                  <p className="info-label-small">Mid de Phrase</p>
                  <h3 className="info-value-main">{studentInfo.midPhrase}</h3>
                  <p className="info-subtext-small">n°xxx le 6/10/2025</p>
                </div>

                <div className="info-card-right">
                  <p className="info-label-small">Matricule</p>
                  <h3 className="info-value-main">{studentInfo.matricule}</h3>
                </div>

                <div className="info-card-right with-icon">
                  <p className="info-label-small">Personnel à contacter</p>
                  <h3 className="info-value-main">{studentInfo.personnelContacter}</h3>
                  <div className="contact-icon-right">👤</div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>

      {/* Add Note Modal */}
      {showAddNoteModal && (
        <div className="note-modal-overlay" onClick={() => setShowAddNoteModal(false)}>
          <div className="note-modal" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close-x" onClick={() => setShowAddNoteModal(false)}>✕</button>

            <h2 className="modal-title-note">Ajout de note au bulletin</h2>

            <form onSubmit={handleNoteSubmit} className="note-form">
              <div className="note-form-group">
                <label>Français communication orale</label>
                <input
                  type="number"
                  name="francaisCommunication"
                  placeholder="14"
                  value={noteFormData.francaisCommunication}
                  onChange={handleNoteInputChange}
                  min="0"
                  max="20"
                />
                <p className="note-helper-text">Veuillez saisir judicieusement la note obtenue par l'élève</p>
              </div>

              <div className="note-form-group">
                <label>Français Expression écrite</label>
                <input
                  type="number"
                  name="francaisExpression"
                  placeholder="13"
                  value={noteFormData.francaisExpression}
                  onChange={handleNoteInputChange}
                  min="0"
                  max="20"
                />
                <p className="note-helper-text">Veuillez saisir judicieusement la note obtenue par l'élève</p>
              </div>

              <div className="note-form-group">
                <label>Français Lecture</label>
                <input
                  type="number"
                  name="francaisLecture"
                  placeholder="17"
                  value={noteFormData.francaisLecture}
                  onChange={handleNoteInputChange}
                  min="0"
                  max="20"
                />
                <p className="note-helper-text">Veuillez saisir judicieusement la note obtenue par l'élève</p>
              </div>

              <div className="note-form-group">
                <label>Français Orthographe</label>
                <input
                  type="number"
                  name="francaisOrthographe"
                  placeholder="04"
                  value={noteFormData.francaisOrthographe}
                  onChange={handleNoteInputChange}
                  min="0"
                  max="20"
                />
                <p className="note-helper-text">Veuillez saisir judicieusement la note obtenue par l'élève</p>
              </div>

              <div className="note-form-group">
                <label>Mathématique</label>
                <input
                  type="number"
                  name="mathematique"
                  placeholder="20"
                  value={noteFormData.mathematique}
                  onChange={handleNoteInputChange}
                  min="0"
                  max="20"
                />
                <p className="note-helper-text">Veuillez saisir judicieusement la note obtenue par l'élève</p>
              </div>

              <div className="note-form-group">
                <label>Education sociale (écrit)</label>
                <input
                  type="number"
                  name="educationSocialeEcrit"
                  placeholder="16"
                  value={noteFormData.educationSocialeEcrit}
                  onChange={handleNoteInputChange}
                  min="0"
                  max="20"
                />
                <p className="note-helper-text">Veuillez saisir judicieusement la note obtenue par l'élève</p>
              </div>

              <div className="note-form-group">
                <label>Education Scientifique et Technologique (écrit)</label>
                <input
                  type="number"
                  name="educationScientifiqueEcrit"
                  placeholder="14"
                  value={noteFormData.educationScientifiqueEcrit}
                  onChange={handleNoteInputChange}
                  min="0"
                  max="20"
                />
                <p className="note-helper-text">Veuillez saisir judicieusement la note obtenue par l'élève</p>
              </div>

              <div className="note-form-group">
                <label>EA Poésie / Chant</label>
                <input
                  type="number"
                  name="eaPoesie"
                  placeholder="09"
                  value={noteFormData.eaPoesie}
                  onChange={handleNoteInputChange}
                  min="0"
                  max="20"
                />
                <p className="note-helper-text">Veuillez saisir judicieusement la note obtenue par l'élève</p>
              </div>

              <div className="note-form-group">
                <label>EA Conte / Couture</label>
                <input
                  type="number"
                  name="eaConte"
                  placeholder="08"
                  value={noteFormData.eaConte}
                  onChange={handleNoteInputChange}
                  min="0"
                  max="20"
                />
                <p className="note-helper-text">Veuillez saisir judicieusement la note obtenue par l'élève</p>
              </div>

              <div className="note-form-group">
                <label>EA Dessin</label>
                <input
                  type="number"
                  name="eaDessin"
                  placeholder="12"
                  value={noteFormData.eaDessin}
                  onChange={handleNoteInputChange}
                  min="0"
                  max="20"
                />
                <p className="note-helper-text">Veuillez saisir judicieusement la note obtenue par l'élève</p>
              </div>

              <div className="note-form-group">
                <label>Education sociale (Anglais)</label>
                <input
                  type="number"
                  name="educationSocialeAnglais"
                  placeholder="17"
                  value={noteFormData.educationSocialeAnglais}
                  onChange={handleNoteInputChange}
                  min="0"
                  max="20"
                />
                <p className="note-helper-text">Veuillez saisir judicieusement la note obtenue par l'élève</p>
              </div>

              <button type="submit" className="validate-btn">
                Valider
              </button>
            </form>
          </div>
        </div>
      )}

      {/* Recommandation Modal */}
      {showRecommandationModal && (
        <div className="note-modal-overlay" onClick={() => setShowRecommandationModal(false)}>
          <div className="recommandation-modal" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close-x" onClick={() => setShowRecommandationModal(false)}>✕</button>

            <h2 className="modal-title-note">Ajout des recommandations</h2>

            <form onSubmit={handleRecommandationSubmit} className="recommandation-form">
              <div className="recommandation-form-group">
                <label>Dites ce que vous recommandez à l'élève.</label>
                <textarea
                  className="recommandation-textarea"
                  placeholder="ex : L'enfant doit redoubler plus d'effort en Mathématique."
                  value={recommandation}
                  onChange={(e) => setRecommandation(e.target.value)}
                  rows="6"
                  required
                />
              </div>

              <button type="submit" className="validate-btn">
                Valider
              </button>
            </form>
          </div>
        </div>
      )}

      {/* Observation Modal */}
      {showObservationModal && (
        <div className="note-modal-overlay" onClick={() => setShowObservationModal(false)}>
          <div className="observation-modal" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close-x" onClick={() => setShowObservationModal(false)}>✕</button>

            <h2 className="modal-title-note">Ajout des observations</h2>

            <form onSubmit={handleObservationSubmit} className="observation-form">
              <div className="observation-form-group">
                <label>Conduite</label>
                <input
                  type="text"
                  name="conduite"
                  placeholder="Ex : Bonne"
                  value={observationData.conduite}
                  onChange={handleObservationInputChange}
                  required
                />
              </div>

              <div className="observation-form-group">
                <label>Assiduité</label>
                <input
                  type="text"
                  name="assiduite"
                  placeholder="Ex : Bonne"
                  value={observationData.assiduite}
                  onChange={handleObservationInputChange}
                  required
                />
              </div>

              <div className="observation-form-group">
                <label>Application</label>
                <input
                  type="text"
                  name="application"
                  placeholder="Ex : Bonne"
                  value={observationData.application}
                  onChange={handleObservationInputChange}
                  required
                />
              </div>

              <button type="submit" className="validate-btn">
                Valider
              </button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default VueEtudiant;
